<template>
    <div style="position:relative">
        <!--文书生成-->
        <div style="width: 100%; height: 100%;position: relative;padding-top: 30px;box-sizing: border-box;position:relative">
            <div class="success"  style="z-index:9878978988789" v-show="successVisible">
            <div class="success-content">
                <span>保存成功</span>
            </div>
        </div>
            <div class="button">
                <input class="secondary" type=button value="打开本地文件" @click="openLocalFile()">
                <input class="secondary" type=button value="保存到服务器" @click="saveToServer()">
                <input class="secondary" style="margin-left:35px;" type=button value="重新生成" @click="openClerkTemplate('1')">
                <input class="main" id="zw_shanying_id" type=button value="缮印" @click="doShanYing()">
                <!--<input class="main" id="zw_shanying_id" type=button value="测是调用上一层" @click="ntkoSendDataToParentPage()">-->
                <input class="close" type=button value="关闭" @click="close_window_method">
            </div>
        </div>
        <a-spin :spinning="spinningLoading">
       <div v-if="browser==='IE'">
                 <div v-if="platform==='Win32'">
                 <object id="TANGER_OCX" :classid="classid" :codebase="codebase" :width="width" :height="height">
                 <param name="MakerCaption" :value="MakerCaption">
                 <param name="MakerKey" :value="MakerKey">
                 <param name="ProductCaption" :value="ProductCaption">
                 <param name="ProductKey" :value="ProductKey">
                 <param name="NoExpireKey" :value="NoExpireKey">
                 <param name="IsUseUTF8URL" value="-1">
                 <param name="IsUseUTF8Data" value="-1">
                 <param name="Caption" value="NTKO OFFICE文档控件示例演示 http://www.ntko.com">
                     <SPAN STYLE="color:red">不能装载文档控件。请在检查浏览器的选项中检查浏览器的安全设置。</SPAN>
                 </object>
               </div>
             <div v-if="platform==='Win64'">
                 <object id="TANGER_OCX" :classid="classidx64" :codebase="codebase64" :width="width" :height="height">
                     <param name="MakerCaption" :value="MakerCaption">
                     <param name="MakerKey" :value="MakerKey">
                     <param name="ProductCaption" :value="ProductCaption">
                     <param name="ProductKey" :value="ProductKey">
                     <param name="NoExpireKey" :value="NoExpireKey">
                     <param name="IsUseUTF8URL" value="-1">
                     <param name="IsUseUTF8Data" value="-1">
                     <param name="Caption" value="NTKO OFFICE文档控件示例演示 http://www.ntko.com">
                     <SPAN STYLE="color:red">不能装载文档控件。请在检查浏览器的选项中检查浏览器的安全设置。</SPAN>
                 </object>
             </div>
         </div>
         <div v-if="browser=='firefox'">
                 <object id="TANGER_OCX" type="application/ntko-plug"  :codebase="chfixclassid" :width="width" :height="height" ForOnSaveToURL="ntkosavetourl"  ForOndocumentopened="ntkoondocumentopened" ForOnpublishAshtmltourl="ntkopublishashtml" ForOnpublishAspdftourl="ntkopublishaspdf" ForOnSaveAsOtherFormatToUrl="ntkosaveasotherurl" :_MakerCaption="MakerCaption" :_MakerKey="MakerKey" :_ProductCaption="ProductCaption" :_ProductKey="ProductKey" :_NoExpireKey="NoExpireKey" :clsid="chfixclassid">
                 <SPAN STYLE="color:red">尚未安装NTKO Web FireFox跨浏览器插件</SPAN>
             </object>
         </div>
        <div v-if="browser=='chrome'">
            关闭
                <object id="TANGER_OCX" type="application/ntko-plug"  :codebase="codebase" :width="width" :height="height" ForOnSaveToURL="ntkosavetourl"  ForOndocumentopened="ntkoondocumentopened" ForOnpublishAshtmltourl="ntkopublishashtml" ForOnpublishAspdftourl="ntkopublishaspdf" ForOnSaveAsOtherFormatToUrl="ntkosaveasotherurl" :_MakerCaption="MakerCaption" :_MakerKey="MakerKey" :_ProductCaption="ProductCaption" :_ProductKey="ProductKey" :_NoExpireKey="NoExpireKey" :clsid="chfixclassid">
                    <SPAN STYLE="color:red">尚未安装NTKO Web Chrome跨浏览器插件</SPAN>
                </object>
        </div>
        </a-spin>
    </div>
</template>

<script>
import ntkoBrowser from '@/views/ntko/ntkobackground.js'
import NtkoInfo from './ntkoInfo.js'

    let ntko;
    export default {
        name: "editindexdemo",
        data(){
            return{
                visible:true,
                //64位控件的calssid
                 /*classidx64:"clsid:A64E3073-2016-4baf-A89D-FFE1FAA10EF2",
                //32位控件的classid
                 classid:"clsid:A64E3073-2016-4baf-A89D-FFE1FAA10ED2",
                //谷歌和火狐的classid
                chfixclassid:"{A64E3073-2016-4baf-A89D-FFE1FAA10ED2}",
                //32位控件包的路径
                codebase:"/3/ntko/kkk/ofctnewclsid.cab#version=6,0,1,0",
                //64位控件包的路径
                 codebase64:"/3/ntko/kkk/ofctnewclsidx64.cab#version=6,0,1,0",
                //设置高度
                height:"1000px",
                //设置宽度
                width:"100%",
                //买断授权密钥如果不是买断可以不用写
                MakerCaption:"广州市翼迅信息科技有限公司",
               //买断授权密钥如果不是买断可以不用写
                MakerKey:"0227F2FBA947ADF126806076A4038CCA0D957300",
                //密钥
               ProductCaption:"广东省环境监测中心",
                //密钥
               ProductKey:"C18A173040D0B4C3F5444F47F0FDAE61625B1F03",
               //解除时间密钥
                NoExpireKey:"",
                //获取浏览器类型
                browser:"",
                //获取操作系统位数
                platform:"",
                NtkoUrlTest:"",*/
                classidx64:NtkoInfo.classidx64(),
                classid:NtkoInfo.classid(),
                chfixclassid:NtkoInfo.chfixclassid(),
                codebase:NtkoInfo.codebase(),
                codebase64:NtkoInfo.codebase64(),
                MakerCaption:NtkoInfo.MakerCaption(),
                MakerKey:NtkoInfo.MakerKey(),
                ProductCaption:NtkoInfo.ProductCaption(),
                ProductKey:NtkoInfo.ProductKey(),
                NoExpireKey:NtkoInfo.NoExpireKey(),
                height:"1000px",
                width:"100%",
                browser:"",
                NtkoUrlTest:"",

                clerkTemplateKey:"",
                referId:"",
                userId:"",
                configKey:"",
                access_token:"",
                orgId:"",
                supplierId:"",//中标通知书的供应商id
                dbFileName:"",//附件的文件名
                pdfConfigKey:"",//word转换成pdf的上传附件的key
                caseId:"",
                spinningLoading:false,
                successVisible:false,
                cPackName:false
            }
        },
        mounted(){

        /*const oScript = document.createElement('script');
        
        oScript.language = 'Jscript';
        oScript.for="TANGER_OCX";

        oScript.event="OnDocumentOpened(file,doc)";
        oScript.src='./kk.js';
        document.body.appendChild(oScript);
        alert("hjkhljkhl");*/
        },
        created(){
            let userAgent = window.navigator.userAgent;
            let browser;
            let version;
            let browserMatch = this.uaMatch(userAgent.toLowerCase());
            if (browserMatch.browser) {
                browser = browserMatch.browser;
                version = browserMatch.version;
            }
            let platform=window.navigator.platform;
            this.platform=platform;
            this.browser=browser;

            this.$nextTick(function () {
                let that=this;
                this.clerkTemplateKey = this.$route.query.clerkTemplateKey;
                this.referId=this.$route.query.referId;
                this.userId=this.$route.query.userId;
                this.configKey=this.$route.query.configKey;
                this.caseId=this.$route.query.caseId;
                this.pdfConfigKey=this.$route.query.pdfConfigKey;
                this.access_token=this.$route.query.access_token;
                this.orgId=this.$route.query.orgId;
                this.projectId=this.$route.query.projectId;
                this.supplierId=this.$route.query.supplierId;
                this.cPackName=this.$route.query.cPackName;
                let ntko = document.getElementById("TANGER_OCX");
                this.initPrint();
               // ntko.openfromurl(process.env.VUE_APP_API_SERVER + '/api/1/ntko/document_file.json?attachmentId=659346ce-daed-4670-a577-c49fe8bb5812' );
               // this.onload_data(this.clerkTemplateKey);//加载数据
            });
        },
        methods:{
             uaMatch(ua) {
                 let rMsie = /(msie\s|trident.*rv:)([\w.]+)/;
                 let rFirefox = /(firefox)\/([\w.]+)/;
                 let rOpera = /(opera).+version\/([\w.]+)/;
                 let rChrome = /(chrome)\/([\w.]+)/;
                 let rSafari = /version\/([\w.]+).*(safari)/;
                let match = rMsie.exec(ua);
                if (match != null) {
                    return { browser : "IE", version : match[2] || "0" };
                }
                let firefoxmatch = rFirefox.exec(ua);
                if (firefoxmatch != null) {
                    return { browser : firefoxmatch[1] || "", version : firefoxmatch[2] || "0" };
                }
                let operamatch = rOpera.exec(ua);
                if (operamatch != null) {
                    return { browser : operamatch[1] || "", version : operamatch[2] || "0" };
                }
                let chromematch = rChrome.exec(ua);
                if (chromematch != null) {
                    return { browser : chromematch[1] || "", version : chromematch[2] || "0" };
                }
                let safarimatch = rSafari.exec(ua);
                if (safarimatch != null) {
                    return { browser : safarimatch[2] || "", version : safarimatch[1] || "0" };
                }
                if (match != null) {
                    return { browser : "", version : "0" };
                }
                return userAgent;
            },

            ntkoSetReturnValueToParentPage(data1,text1){
                let ntkojb=this.NtkoJudgingBrowsers();
                if(ntkojb){
                    window.opener.eventBus.$emit(data1,text1)
                }else {
                    window.external.SetReturnValueToParentPage(data1, text1);
                }
            },
            NtkoJudgingBrowsers(){
                try{
                    let ntkobtop=window.opener.top.browser;
                    return true;
                }catch(err){
                    return false;
                }
            },
            NtkoPerClose(){
                let ntkoarry=new Array();
                ntkoarry.push(this.NtkoUrlTest);
                this.ntkoSetReturnValueToParentPage("ntkoSendclose",ntkoarry);
            },
            ntkourltext(){
                this.NtkoUrlTest= window.location.href;
                if(this.NtkoUrlTest!=null&&this.NtkoUrlTest!=""){
                    let ntkoarry=new Array();
                    ntkoarry.push(this.NtkoUrlTest);
                    this.ntkoSetReturnValueToParentPage("ntkoSendDataToChildtext",ntkoarry);
                }
            },







             //打开本地文件
            openLocalFile(){
                let that=this;
                let ntko = document.getElementById('TANGER_OCX');
                //ntko.ShowDialog(1);
                //let openDoc="word.document";
                //ntko.ondocumentopened("d://",openDoc);
                //alert(openDoc);
            },

             //缮印
            doShanYing(){
                let that=this;
                let ntko = document.getElementById('TANGER_OCX')
                var seal_path=process.env.VUE_APP_WEB_SERVER +"/Dmcomponents/Templates/seal/zztender.gif";
                //alert(111);
                //var seal_path="../../../public/Dmcomponents/Templates/seal/广东志正招标有限公司.gif";
                //var seal_path="../../../img/2.gif"
               // var seal_path="file:///D:/2.gif"; 
                //alert(seal_path);
                
                ntko.AddPicFromURL(seal_path, true, 0,0, 1, 100, 0);            
            },

            //关闭窗口
            close_window_method(){
                //ntkoBrowser.ntkoClose(process.env.VUE_APP_WEB_SERVER  +"/#/clerktemplate/test");
                window.close();
            },

            ntkoSendDataToParentPage(){ 
                let varData = new Array();
                let ntko = document.getElementById('TANGER_OCX');
                let ntkoarray='{"docsize":'+ntko.docsize+","+'"referId":"'+this.referId+'","CurentTime":"'+this.CurentTime+'"}';
                varData.push(ntkoarray);
                this.ntkodatatext=ntkoarray;
                //this.close_window_method();//关闭
                this.ntkoSetReturnValueToParentPage("NtkoSuccess",varData);
                
            },


            openClerkTemplate(onlyQueryClerkTemplate){
                let that=this;
                let confirmFlag=confirm("此操作将利用文书模板重新生成文书，您所做的手工修改将消失，确定吗？");
                if(confirmFlag){
                    this.initPrint(onlyQueryClerkTemplate);
                }
                
            },

            //初始化模板信息
            initPrint(onlyQueryClerkTemplate) {
                let that=this;
                if(!this.clerkTemplateKey){
                    alert("请传递clerkTemplateKey");
                    return;
                };
                let ntko = document.getElementById('TANGER_OCX');
                ntko.TitleBar=false;
                let url='/api/1/clerktemplate/exists_clerk_template_by_clerk_template_key.json?clerkTemplateKey=' + this.clerkTemplateKey+"&orgId="+this.orgId+"&configKey="+'CLERK.TEMPLATE'+"&referId="+this.referId+"&referConfigKey="+this.configKey;
                if(onlyQueryClerkTemplate){
                    url+="&onlyQueryClerkTemplate="+onlyQueryClerkTemplate;
                }
                if(this.caseId){
                    url+="&attachmentId="+this.caseId;
                }
                
                this.spinningLoading=true;
                that.$http.get(url).then(function (data) {
                    that.spinningLoading=false;
                    if (data.result.state === "0") {//表示存在文书模板
                        that.dbFileName= data.result.name;
                        if(data.result.downloadUrl){
                            ntko.OpenFromURL(data.result.downloadUrl);
                        }else{
                            alert('找不到文件的网络路径');
                        }
                        //zzkuaicai.oss-cn-shenzhen.aliyuncs.com/CLERK_TEMPLATE/2020/7/21/5d45abb8-dec2-4212-9bfb-61d2c2101158.doc
                        //alert("12312h3jkh1jk23hj1j2h3");
                        //ntko.OpenFromURL("//zzkuaicai.oss-cn-shenzhen.aliyuncs.com/CLERK_TEMPLATE/2020/7/21/5d45abb8-dec2-4212-9bfb-61d2c2101158.doc");
                        //ntko.OpenFromURL(process.env.VUE_APP_API_SERVER + '/api/1/ntko/document_file.json?attachmentId=' + data.result.attachmentId)//如果找不到会报文件传输错误
                        if(!data.result.isNotClerkTemplate){//如果是文书 不是附件
                            that.onload_data(that.clerkTemplateKey);//加载数据
                        }else if(onlyQueryClerkTemplate){
                            that.onload_data(that.clerkTemplateKey);//加载数据
                        }

                    if (window.innerHeight) {
                        $("#doc_info").height(window.innerHeight);
                      } else {
                        $("#doc_info").height($(document).height());
                      }
                    } else if (data.result.state === "1") {
                        alert("未找到文书模板，请联系OA系统管理员处理。");
                    } else if (data.result.state === "2") {
                        alert("未找到附件上传模板，请联系OA系统管理员处理。");
                    }else if (data.result.state === 400) {
                        alert("请求失败，请联系OA系统管理员处理。400");
                    }
                });
            },

            //保存到服务器
            saveToServer(){
                let that=this;
                let ntko = document.getElementById("TANGER_OCX");
                if(ntko.DocType!=1&&ntko.DocType!=6){
                    alert("请选择文件后缀是doc或者docx的文件");
                    return;
                }
                if(!this.referId){
                    alert("请传递referId");
                    return;
                }else if(!this.configKey){
                    alert("请传递configKey");
                    return;
                };
                let fileName=this.dbFileName;
                /*if(this.dbFileName){
                    fileName=prompt("请输入文件名（包括后缀）",this.dbFileName);//对话框
                }else{
                    fileName=prompt("请输入文件名（包括后缀）");//对话框
                }*/
                
                if(!fileName){
                    alert("请填写文件名");
                    return;
                }else{
                    var result=ntko.saveToURL(process.env.VUE_APP_API_SERVER + '/api/1/ntko/clerk_upload_cover.json','FileData',"referId="+this.referId+"&configKey="+this.configKey+"&userId="+this.userId+"&fileName="+fileName+"&attachmentId="+(this.caseId?this.caseId:"")+"&pdfConfigKey="+(this.pdfConfigKey?this.pdfConfigKey:""), 0   //上传文件的名称，类似<input type=file 的value0    //与控件一起提交的表单id，也可以是form的序列号，这里应该是0.
                    );
                    var resultJsonObj = JSON.parse(result);
                    if(resultJsonObj.code==200){
                        //alert("保存成功！");
                        this.openSuccessModal();
                        this.ntkoSendDataToParentPage();
                    }else{
                        alert(resultJsonObj.code);
                        alert(resultJsonObj.msg);
                        alert("保存失败！");
                    }
                }
            },

            onload_data(clerkTemplateKey) {
                if(clerkTemplateKey === "CJRFKHGFF_CJTZS"){
                    this.operationCJRFKHGFF_CJTZS();
                }            
            },

            //获取数据
            operationCJRFKHGFF_CJTZS(){
                if(!this.supplierId||!this.projectId){
                    return;
                }
                let that=this;
                let ntko = document.getElementById('TANGER_OCX');
                this.spinningLoading=true;
                that.$http.get('/api/1/category/getCjCategory.json?projectId='+this.projectId+"&supplierId="+this.supplierId).then(function (data) {
                    that.spinningLoading=false;
                    if (data.code !== 200) {
                        return
                    }
                    if(data.code==200){
                        ntko.SetBookmarkValue('xmmc', data.result.xmmc?data.result.xmmc:"");    
                        ntko.SetBookmarkValue('xmbh', data.result.xmbh?data.result.xmbh:"");
                        ntko.SetBookmarkValue('xmbh1', data.result.xmbh?data.result.xmbh:"");
                        let packInfo="";
                        let zbcjgysmc="";
                        if(data.result.supplierCjList){//供应商成交列表 手动拼接包组
                            for(let scji=0;scji<data.result.supplierCjList.length;scji++){
                                const offerType = data.result.supplierCjList[scji].offer_type
                                const offerTypeText = offerType=='1'?"金额":offerType=='2'?"折扣率":"下浮率"
                                const priceText = offerType=='1'?"元":"%"
                                if(that.cPackName&&(that.cPackName.indexOf(data.result.supplierCjList[scji].pack_code)<0)){//不是成交的包组
                                    continue;
                                }
                                if(data.result.supplierCjList[scji].supplier_name){
                                    zbcjgysmc=data.result.supplierCjList[scji].supplier_name;
                                }                  
                                if(data.result.supplierCjList[scji].length==1){
                                    packInfo+="成交"+offerTypeText+"："+(offerType=='1'?data.result.supplierCjList[scji].quoted_price:(data.result.supplierCjList[scji].quoted_price*100).toFixed(2))+priceText;
                                }else{
                                    //packInfo+=(scji+1)+"."+data.result.supplierCjList[scji].indexNum+"："+data.result.supplierCjList[scji].pack_name;
                                    packInfo+="成交包组："+data.result.supplierCjList[scji].pack_name+"（"+data.result.supplierCjList[scji].pack_code+"）";
                                    packInfo+=String.fromCharCode(10);
                                    packInfo+="成交"+offerTypeText+"："+(offerType=='1'?data.result.supplierCjList[scji].quoted_price:(data.result.supplierCjList[scji].quoted_price*100).toFixed(2))+priceText;
                                }
                                if(scji!=data.result.supplierCjList.length-1){
                                    packInfo+=String.fromCharCode(10);
                                }  
                            }
                        }
                        ntko.SetBookmarkValue('zbcjgysmc', zbcjgysmc?zbcjgysmc:"");
                        ntko.SetBookmarkValue('sybzxq', packInfo?packInfo:"");
                        ntko.SetBookmarkValue('cgrmc', data.result.cgrmc?data.result.cgrmc:"");
                        ntko.SetBookmarkValue('cgrdz', data.result.cgrdz?data.result.cgrdz:"");
                        ntko.SetBookmarkValue('cgrlxr', data.result.cgrlxr?data.result.cgrlxr:"");
                        ntko.SetBookmarkValue('cgrlxdh', data.result.cgrlxdh?data.result.cgrlxdh:"");
                        ntko.SetBookmarkValue('cgrsjh', data.result.cgrsjh?data.result.cgrsjh:(data.result.cgrbgdh?data.result.cgrbgdh:""));
                        ntko.SetBookmarkValue('cgrbgdh', data.result.cgrbgdh?data.result.cgrbgdh:"");
                        
                        ntko.SetBookmarkValue('cgrdzyj', data.result.cgrdzyj?data.result.cgrdzyj:"");
                        ntko.SetBookmarkValue('xmzbr', data.result.xmzbr?data.result.xmzbr:"");
                        ntko.SetBookmarkValue('xmxbr', data.result.xmxbr?data.result.xmxbr:"");
                        ntko.SetBookmarkValue('xmlxdh', data.result.xmlxdh?data.result.xmlxdh:"");
                        ntko.SetBookmarkValue('xmdzyj', data.result.xmdzyj?data.result.xmdzyj:"");
                        ntko.SetBookmarkValue('cgfs', data.result.cgfs?data.result.cgfs:"");
                        ntko.SetBookmarkValue('ggfbsj', data.result.ggfbsj?data.result.ggfbsj:"");
                        ntko.SetBookmarkValue('bmjzsj', data.result.bmjzsj?data.result.bmjzsj:"");
                        ntko.SetBookmarkValue('jjkbsj', data.result.jjkbsj?data.result.jjkbsj:"");
                        ntko.SetBookmarkValue('gyszgyq', data.result.gyszgyq?data.result.gyszgyq:"");
                        ntko.SetBookmarkValue('xmsm', data.result.xmsm?data.result.xmsm:"");
                        ntko.SetBookmarkValue('dljgmc', data.result.dljgmc?data.result.dljgmc:"");
                        ntko.SetBookmarkValue('dqri', data.result.dqri?data.result.dqri:"");
                        ntko.SetBookmarkValue('dljgdz', data.result.dljgdz?data.result.dljgdz:"");
                        ntko.SetBookmarkValue('dqrizwnyr', data.result.dqrizwnyr?data.result.dqrizwnyr:"");
                        var activeDocument = ntko.ActiveDocument;
                        if (activeDocument.BookMarks.Exists('sy')) {//印章书签
                            activeDocument.Application.Selection.GoTo(-1,0,0,'sy');
                            //var seal_path="/Dmcomponents/Templates/seal/广东志正招标有限公司.gif";
                            var seal_path=process.env.VUE_APP_WEB_SERVER +"/Dmcomponents/Templates/seal/zztender.gif";
                           // var seal_path="../../../public/Dmcomponents/Templates/seal/广东志正招标有限公司.gif"
                            ntko.SetBookmarkValue('sy', "");
                            ntko.AddPicFromURL(seal_path, true, -100,-80, 1, 100, 0);//-100往左 -80往上
                        }
                    } 
                })
            },

             //提示成功
            openSuccessModal(){
                let that=this;
                //that.$message.success('推送成功')
                this.successVisible=true;
                 setTimeout(function () {
                   that.successVisible=false;
                }, 1500);
            }
        }
    }
</script>

<style scoped>
        #doc_info {
            position: relative;
            padding: 0px;
            border: 0px solid #E8E9F7;
            background-color: white;
            z-index: 99;
            overflow: auto;
            width: 100%;
            height: 100%;
            z-index: 99;
        }

        #history_list table {
            border-right: 1px solid #000000;
            border-bottom: 1px solid #000000
        }

        #history_list table td {
            border-left: 1px solid #000000;
            border-top: 1px solid #000000;
            height: 34px;
        }

        .button {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }

        .button input {
            cursor: pointer;
            display: inline-block;
            background: #1890ff;
            border: none;
            padding: 0 20px;
            color: #fff;
            height: 22px;
            margin: 0px 2px;
            box-shadow: 0px 2px 0px 0px #1368b7;
            border-radius: 3px;
            padding-top: 2px;
            margin-left: 10px;
        }

        .button .close {
            background: #dd484b;
            box-shadow: 0px 2px 0px 0px #b71a28;
        }

        .button .secondary {
            background: #ff890a;
            box-shadow: 0px 2px 0px 0px #b74e0d;
        }

        .close_input {
            display: inline-block;
            border: none;
            padding: 0 20px;
            color: #fff;
            height: 22px;
            margin: 0px 2px;
            background: #dd484b;
            box-shadow: 0px 2px 0px 0px #b71a28;
            border-radius: 3px;
            padding-top: 2px;
        }

         .success {
            position: absolute;
            width:40px;
            left:50%;
            top:1%;
        }

        .success-content {
            width: 100px;
            height: 40px;
            margin: 0 auto;
            padding: 10px 16px;
            background: #fff;
            color: #87d068;
            text-align: center;
        }
</style>